export default __webpack_public_path__ + "static/media/Benefits.1391d2db.png";